import React from 'react';
import visaCard from '../../../../../../assets/image/subscription/visa-icon.svg';

export default function SubscriptionBankCard({ card }) {
	return (
		<div className="subscription-bank-card p-4 m-2 rounded-4">
			<div className="d-flex justify-content-between align-items-end">
				<div>
					<div className="fs-3 fw-bold text-dark py-1">{card.card_type}</div>
					<div className="fs-4 fw-semibold text-dark py-1">{card.card_number}</div>
					<div className="fs-5 fw-light text-dark py-1">{`Expiring ${card.expiry_date}`}</div>
				</div>
				<div>
					<img
						width={40}
						height={40}
						src={visaCard}
						alt="icon"
					/>
					<div
						className="p-1 fs-5 fw-light rounded-4"
						style={{ color: card.status === 'Active' ? '#68C230' : '#dc3545' }}
					>
						{card.status}
					</div>
				</div>
			</div>
		</div>
	);
}
